import React from 'react';
import { compose } from '@reduxjs/toolkit';
import { CartAppState, connectFromCart } from '@cart-js/core';
import { CommonHeaderPropsWrapper } from 'core/type/header.types';
import { ActivitiesHeader } from 'component/common/Header/ActivitiesHeader';
import { RightHeaderItemsProps } from '@agoda/layout/lib/component/desktop/Header/type';
import { selectHeaderShoppingCartProps } from 'core/utils/cartIngress.selectors';
import { LazyCartIcon } from 'core/utils/lazyCart';

type Props = CommonHeaderPropsWrapper & RightHeaderItemsProps;

export const renderCartIcon = (onClick: () => void) => {
    return <LazyCartIcon onClick={onClick} />;
};

const LazyActivitiesHeaderComponent = React.memo((props: Props) => {
    const newHeaderProps = {
        ...props.header,
        rightHeaderItemsProp: {
            shoppingCart: props.shoppingCart,
            renderCartIcon,
        },
    };

    return <ActivitiesHeader {...props} header={newHeaderProps} />;
});
LazyActivitiesHeaderComponent.displayName = 'LazyActivitiesHeaderComponent';

const mapCartStateToProps = (cartState: CartAppState): RightHeaderItemsProps => ({
    shoppingCart: selectHeaderShoppingCartProps(cartState),
});

const LazyActivitiesHeader = compose(connectFromCart<RightHeaderItemsProps, {}, CommonHeaderPropsWrapper>(mapCartStateToProps))(LazyActivitiesHeaderComponent);
LazyActivitiesHeader.displayName = 'LazyActivitiesHeader';

export { LazyActivitiesHeader as default, LazyActivitiesHeaderComponent };
